import { TValueForService } from "../../../../../../../services/api/instances/storageApi/types/service_types";
import { useAppSelector } from "../../../../../../../services/redux/hooks/use-selector";
import { AppSwitch } from "../../../../../../../shared/components/AppSwitch";
import { getUpdatedChatbotValue } from "../../../../../helpers/getUpdatedChatbotValue";
import { selectChatbotValue } from "../../../../../redux/selectors";
import styles from "./styles.module.css";

interface Props {
  saveChatbotValue: (
    value: TValueForService<"ai_agents_telegram_bots">,
  ) => void;
  label: string;
}

export const DialogHistorySwitcher = (props: Props) => {
  const botValue = useAppSelector(selectChatbotValue);

  const handleToggleHistoryMessages = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (!botValue?.tg_bot_object) return;
    const updatedValue = getUpdatedChatbotValue(botValue, {
      log_message: event.target.checked,
    });
    props.saveChatbotValue(updatedValue);
  };

  return (
    <div className={styles["switch-container"]}>
      <AppSwitch
        className={styles.switch}
        checked={botValue?.tg_bot_object?.log_message ?? false}
        onChange={handleToggleHistoryMessages}
      />
      <span className={styles["switch-label"]}>{props.label}</span>
    </div>
  );
};
